import { Outlet } from "react-router"

import { withAuthenticationRequired } from "@auth0/auth0-react"

import { ProfileContextProvider } from "@/context/ProfileContext"

export const AuthLayout = withAuthenticationRequired(({ children }: { children?: React.ReactNode }) => {
  return <ProfileContextProvider>{children || <Outlet />}</ProfileContextProvider>
})
export default AuthLayout
